// @flow

import * as React from 'react'
import { withState } from 'recompose'
import { Popup } from 'semantic-ui-react'
import { CopyToClipboard as ReactCopyToClipboard } from 'react-copy-to-clipboard'

// NOTE: this type is unnecessary if semantics libdefs work correctly
type ToolTipPosition =
  | 'top left'
  | 'top right'
  | 'bottom right'
  | 'bottom left'
  | 'right center'
  | 'left center'
  | 'top center'
  | 'bottom center'

// TODO (quinkinser) WIP
type RecomposeProps = {|
  copied: boolean,
  +onCopy: Function
|}

type OwnProps = {|
  successTooltipText?: string,
  successTooltipPosition?: ToolTipPosition,
  clipboardContent: string,
  children: React.Node
|}

type Props = {|
  ...RecomposeProps,
  ...OwnProps
|}

const CopyToClipboard = ({
  copied,
  onCopy,
  successTooltipText,
  successTooltipPosition,
  clipboardContent,
  children
}: Props) => (
  <Popup
    open={copied}
    content={successTooltipText}
    position={successTooltipPosition}
    inverted
    trigger={
      <ReactCopyToClipboard
        text={clipboardContent}
        onCopy={() => {
          onCopy(true)
          setTimeout(() => onCopy(false), 500)
        }}
      >
        {children}
      </ReactCopyToClipboard>
    }
  />
)

CopyToClipboard.defaultProps = {
  successTooltipText: 'Copied!',
  successTooltipPosition: 'bottom center'
}

export default withState('copied', 'onCopy', false)(CopyToClipboard)



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/ModalManager/components/CopyToClipboard.js